import { render, staticRenderFns } from "./WalletAuthorization.vue?vue&type=template&id=79f679be&scoped=true"
import script from "./WalletAuthorization.vue?vue&type=script&lang=js"
export * from "./WalletAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f679be",
  null
  
)

export default component.exports